module.exports = __webpack_public_path__ + "img/image.dcd7b6e8.png";